import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad1661fc&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ad1661fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0__css-load_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1661fc",
  null
  
)

export default component.exports